import Text from "lib/components/Text"
import Button from "lib/components/Button"
import { useContext, useState } from "react"
import { LanguageContext } from "context/LanguageContext"
import Modal from "lib/components/Modal"
import { gtmEvent } from "lib/gtm"
import Image from "next/image"
import { scrollToTargetSection } from "../Business/Hero"

export default function FreeTrial() {
  const { useTranslation: t } = useContext(LanguageContext)
  const [visible, setVisible] = useState<boolean>(false)

  return (
    <>
      <section className="bg-primary">
        <div className="container mx-auto px-4 lg:px-0 relative py-8 lg:py-[52px] flex flex-col-reverse lg:flex-row items-center justify-center gap-6 lg:gap-0">
          <div className="w-full lg:w-1/2">
            <div
              role="button"
              tabIndex={0}
              onClick={() => {
                setVisible(true)
              }}>
              <Image
                src="/assets/images/free-trial-macbook.webp"
                alt="Free trial video"
                width={582}
                height={322}
                sizes="(max-width: 1023px) 100vw, 582px"
              />
            </div>
          </div>
          <div className="w-full lg:w-1/2 relative flex flex-row items-center justify-center">
            <div className="hidden lg:block absolute -top-[40%] left-[3%]">
              <Image src="/assets/svg/sparkle.svg" alt="Sparkle" width={20} height={20} />
            </div>
            <div className="hidden lg:block absolute -top-[32%] right-[14%]">
              <Image src="/assets/svg/sparkle.svg" alt="Sparkle" width={25} height={25} />
            </div>
            <div className="hidden lg:block absolute bottom-0 right-[11%]">
              <Image src="/assets/svg/sparkle.svg" alt="Sparkle" width={20} height={20} />
            </div>
            <div className="hidden lg:block absolute -bottom-[30%] left-[23.5%]">
              <Image src="/assets/svg/sparkle.svg" alt="Sparkle" width={25} height={25} />
            </div>
            <div className="flex flex-col items-center lg:items-start gap-6 lg:gap-10 w-full lg:max-w-[472px]">
              <div className="flex flex-col items-center lg:items-start gap-3">
                <div className="flex flex-row items-center gap-2 lg:gap-3">
                  <div className="bg-danger rounded-tl-lg rounded-br-lg lg:rounded-tl-[20px] lg:rounded-br-[20px] py-1 px-3">
                    <Text weight="semibold" color="light" customClass="text-xs lg:text-xl">
                      {t("free").toUpperCase()} {t("trial")}
                    </Text>
                  </div>
                  <Text color="light" weight="semibold" customClass="text-base lg:text-2xl">
                    {t("in_house_program")}
                  </Text>
                </div>
                <Text color="light" customClass="text-center lg:text-start text-sm lg:text-base">
                  {t("free_trial_description")}
                </Text>
              </div>
              <Button
                onClick={() => {
                  scrollToTargetSection("top page")
                  gtmEvent("ce_section_engagement", {
                    section_name: t("corporate_solution"),
                    button_name: t("see_all_program"),
                  })
                }}
                color="white"
                colorText="primary"
                variant="contained"
                customClass="!shadow-none w-fit max-w-[200px] h-[44px] !text-sm lg:!text-base !font-semibold !tracking-normal">
                {t("start_free_trial")}
              </Button>
            </div>
          </div>
        </div>
      </section>
      {visible && (
        <Modal onClose={() => setVisible(false)}>
          <div className="w-full pt-2 mx-auto my-4 aspect-video">
            <iframe
              className="w-full h-full"
              src="https://www.youtube.com/embed/lkJH7CdhgTs?si=coJMqLQjJ_pN0WGr"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
        </Modal>
      )}
    </>
  )
}
